export { default } from "./RichTextHeading";
